const config = () => {
    return {
        ipServer: "https://msn.thais.ovh",
        // ipServer: "msn-js.herokuapp.com",
        // ipServer: "http://localhost:80",
    };
};

export { config };
